import React, { useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faVideo, faMusic, faFile, faTimes } from '@fortawesome/free-solid-svg-icons';

interface AttachmentPreviewProps {
  file: File;
  onRemove: () => void;
}

const AttachmentPreview: React.FC<AttachmentPreviewProps> = ({ file, onRemove }) => {
  const isImage = file.type.startsWith('image/');

  const previewUrl = useMemo(() => {
    if (isImage) {
      return URL.createObjectURL(file);
    }
    return null;
  }, [file, isImage]);

  const formatSize = (bytes: number): string => {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  };

  return (
    <div className="chat-attachment-preview">
      {isImage && previewUrl ? (
        <img src={previewUrl} alt={file.name} className="chat-attachment-preview__image" />
      ) : (
        <div className="chat-attachment-preview__file-icon">
          <FontAwesomeIcon icon={file.type.includes('pdf') ? faFilePdf : file.type.startsWith('video/') ? faVideo : file.type.startsWith('audio/') ? faMusic : faFile} />
        </div>
      )}
      <div className="chat-attachment-preview__info">
        <span className="chat-attachment-preview__name">{file.name}</span>
        <span className="chat-attachment-preview__size">{formatSize(file.size)}</span>
      </div>
      <button className="chat-btn chat-btn--icon chat-attachment-preview__remove" onClick={onRemove}>
        <FontAwesomeIcon icon={faTimes} />
      </button>
    </div>
  );
};

export default AttachmentPreview;
